import './transporter_details.css';
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { BLOCK_LIST, CONTACT_PERSON_FIRST_NAME_ERROR, GENDER, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE, SALUTATION, INVALID_OTP_ERROR, MOBILE_NO_ERROR, ADDRESS_ERROR, LINKS } from '../../../../common/constants';
// import { Container, Row, Col, Stack } from 'react-bootstrap';
import { emailValidation, isValidName, maxNameLength, emailUrnPassMaxLength,nameValidation, VALIDATION, typeNumberValid } from '../../../../common/commonValidations';
import resolveIcon from "../../../../images/resolved.png";
import { sendOTP, validateOTP } from '../../../../common/Utils';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
// import {Typography,Fab } from '@mui/material';
import { PROD } from '../../../../common/constants';
import BackButton from '../../../../common/backButton';
import { Button, Container, Card, CardContent, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { CommonPincodeMUI } from '../../../../common/common-pincode/commonPincodeMUI';
import { t } from 'i18next';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';
import { ArrowForwardIosIcon, CloseIcon } from '../../../../common/icons';
import BadgeComponent from '../../../../common/badge';
import { addressMaxLength, mobileNoMaxLength, totalClumpsMaxLength, mobileNumberValidation, otpMaxLength, pincodeValidation, plotValidationForKatha, plotValidationForOtherUnits, totalNumberOfClumpValidation, totalPlotsMaxLength} from '../../../../common/commonValidations';


const TransporterDetails = () => {
    const location = useLocation();
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [otpValue, setOtpValue] = useState()
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [localTransporterDetails, setLocalTransporterDetails] = useState(JSON.parse(localStorage.getItem('tranporterDetails')));
    const [selectedApplicant, setSelectedApplicant] = useState(localTransporterDetails?.applicantType ? localTransporterDetails?.applicantType : 'Individual');
    // const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const initialData = {
        fullName: localTransporterDetails?.name ? localTransporterDetails?.name : '',
        mobileNo: localTransporterDetails?.mobileNo ? localTransporterDetails?.mobileNo : '',
        contactPersonName: '',
        pincode: localTransporterDetails?.pincode ? localTransporterDetails?.pincode : '',
        state: localTransporterDetails?.state ? localTransporterDetails?.state : '',
        district: localTransporterDetails?.district ? localTransporterDetails?.district : '',
        subDivision: localTransporterDetails?.subDivision ? localTransporterDetails?.subDivision : '',
        address: localTransporterDetails?.address ? localTransporterDetails?.address : '',
        emailId: localTransporterDetails?.emailId ? localTransporterDetails?.emailId : '',
        contactPersonFirstName: localTransporterDetails?.contactPersonFirstname ? localTransporterDetails?.contactPersonFirstname : '',
        contactPersonMiddleName: localTransporterDetails?.contactPersonMiddlename ? localTransporterDetails?.contactPersonMiddlename : '',
        contactPersonLastName: localTransporterDetails?.contactPersonLastname ? localTransporterDetails?.contactPersonLastname : '',
        contactPersonSalutation: localTransporterDetails?.contactPersonSalutation ? localTransporterDetails?.contactPersonSalutation : SALUTATION[0],
        contactPersonGender: localTransporterDetails?.contactPersonGender ? localTransporterDetails?.contactPersonGender : 'Male',
        revenueCircle: localTransporterDetails?.revenueCircle ? localTransporterDetails?.revenueCircle : '',
        blockName: localTransporterDetails?.blockName ? localTransporterDetails?.blockName : '',
        acceptedTerms: localTransporterDetails?.acceptedTerms ? localTransporterDetails?.acceptedTerms : '',

    };
    const [details, setDetails] = useState(initialData);
    const [detailsFromVehiclePage, setDetailsFromVehiclePage] = useState({});
    const [checkTermChecked, setCheckTermChecked] = useState(initialData.acceptedTerms);
    const [checkTermDisable, setCheckTermDisable] = useState(initialData.acceptedTerms);
    useEffect(() => {
        setDetailsFromVehiclePage(location.state.data)
        if (!location.state.mobileValidation) {
            setMobileOTPValidated(false);
            setVerifyMobileNo(false);
            setCheckTermChecked(false);
            setCheckTermDisable(false);
        }
        else {
            setMobileOTPValidated(true);

        }
    }, [localTransporterDetails]);
    const initialError = {
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        fullNameError: '',
        emailIdError: '',
        contactPersonNameError: '',
        addressError: ''
    };
    const [errorMessage, setErrorMessage] = useState(initialError);
    const navigate = useNavigate();
    const clear = (e) => {
        setDetails();
        setMobileOTPValidated(false);
        setCheckTermChecked(false);
        setCheckTermDisable(false);
        setOtpHidden(true);
        setVerifyMobileNo(false);
        setLocalTransporterDetails();
        setErrorMessage(initialError);
    }
    const handleCheckboxTerms = (e) => {
        if (e.target.checked) {
            e.preventDefault();
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setOtpValue("");
            if (isValidMobileNumber(details.mobileNo)) {
                sendOTP(details.mobileNo, callBackMobileValidation);
                setErrorMessage({ ...errorMessage, mobileNoError: "", acceptTermError: "" });
                setCheckTermChecked(true);
                setCheckTermDisable(true);
            }
            else {
                setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
                setCheckTermChecked(false);
            }
        }
    }
    const onBackButtonClick = () => {
        localStorage.clear()
        navigate('/webRegSidebar')
    }
    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(details.mobileNo)) {
            sendOTP(details.mobileNo, callBackMobileValidation);
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }
    const callBackMobileValidation = (response) => {
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "", mobileNoError: "", OTPError: "", acceptTermError: "" })
            setVerifyMobileNo(true);
            setOtpHidden(false);
        }

    }
    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPError:"", OTPSentError: "", mobileNoError: "", acceptTermError: "" });
        if (response.isSuccess === true) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
        }
        else {
            setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
        }
    }
    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }
    const handleChange = (e) => {

  if (e.target.name === "fullName") {

    // 1) Clean + limit:

    const cleanedValue = e.target.value.replace(/[^a-zA-Z0-9&/ ]/g, "").slice(0, 100);

    // 2) Save cleaned value only once:

    setDetails({

      ...details,

      [e.target.name]: cleanedValue

    });

    // 3) Validate cleaned value:

    if (cleanedValue.length > 0) {

      const Fullname_regex = /^[a-zA-Z0-9 ]+$/;

      if (!Fullname_regex.test(cleanedValue)) {

        setErrorMessage({

          ...errorMessage,

          fullNameError: "Please provide valid Name"

        });

      } else {

        setErrorMessage({

          ...errorMessage,

          fullNameError: ""

        });

      }

    } else {

      setErrorMessage({

        ...errorMessage,

        fullNameError: "Please enter Name of Applicant"

      });

    }

  } else {

    // For other fields, normal update:

    setDetails({

      ...details,

      [e.target.name]: e.target.value

    });

  }


        if (e.target.name === "address") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 300)) })
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR })
        }
        if (e.target.name === "contactPersonFirstName") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
                if (isValidName(e.target.value)) {
                    setErrorMessage({ ...errorMessage, contactPersonNameError: "" })
                } else setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter valid name of contact person" })
            } else {
                setErrorMessage({ ...errorMessage, contactPersonNameError: CONTACT_PERSON_FIRST_NAME_ERROR })
            }

        }
        if (e.target.name === "contactPersonMiddleName") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
            } else return
        }
        if (e.target.name === "contactPersonLastName") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
            } else return
        }

        if (e.target.name === "emailId") {
            if ((e.target.value).length > 0) {
                if (emailValidation(e.target.value.slice(0, 50))) {
                    setErrorMessage({ ...errorMessage, emailIdError: "" })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid email" })
            } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" })
        }
        if (e.target.name === "mobileNo") {
            const limit = 10;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit mobile number" });
            }
            else setErrorMessage({ ...errorMessage, mobileNoError: "" });

        }
        if (e.target.name === "pincode") {
            const limit = 6;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 6) {
                setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
            }
            else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }
    }
    const onApplicantClick = (e, applicantSelected) => {
        e.preventDefault();
        setSelectedApplicant(e.target.value)
        // if (applicantSelected === 'Individual') {
        //     setSelectedApplicant('Individual')

        // } else if (applicantSelected === 'Firm') {
        //     setSelectedApplicant('Firm')
        // } else if (applicantSelected === 'Company') {
        //     setSelectedApplicant('Company')
        // }
    }

    const onClickNext = (e) => {
        e.preventDefault();
        if ((!details.fullName)) {
            setErrorMessage({ ...errorMessage, fullNameError: "Please enter Name of Applicant" });
            return;
        }
        else if (!details.contactPersonFirstName) {
            setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter Full Name of authorised contact person" });
            return;
        }
        else if (!details.mobileNo) {
            setErrorMessage({ ...errorMessage, mobileNoError: "Please enter mobile number" });
            return;
        }
        else if (!details.emailId) {
            setErrorMessage({ ...errorMessage, emailIdError: "Please enter email address" });
            return;
        }
        else if (!details.address) {
            setErrorMessage({ ...errorMessage, addressError: "Please enter Address" });
            return;
        }
        else if (details.pincode.length < 6) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
            return;
        }
        else if (!details?.state) {
            setErrorMessage({ ...errorMessage, searchError: "Please Click Pincode Search Icon " });
            return;
        }
        else if (!checkTermChecked) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please accept the Privacy Policy and Terms of Use of ABEPL." });
            return;
        }
        else if (!mobileOTPValidated && verifyMobileNo) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please enter the OTP sent to your mobile number" });
            return false;
        }
        const dataToBePassed = {
            "applicantType": selectedApplicant,
            "name": details.fullName,
            "contactPersonName": details.contactPersonFirstName,
            "contactPersonFirstname": details.contactPersonFirstName,
            "contactPersonMiddlename": details.contactPersonMiddleName,
            "contactPersonLastname": details.contactPersonLastName,
            "contactPersonGender": details.contactPersonGender,
            "contactPersonSalutation": details.contactPersonSalutation,
            "mobileNo": details.mobileNo,
            "emailId": details.emailId,
            "pincode": details.pincode,
            "address": details.address,
            "state": details.state,
            "district": details.district,
            "subDivision": details.subDivision,
            "revenueCircle": details.revenueCircle,
            "blockName": details.blockName,
            "otp": otpValue,
            "isOtpValidated": true,
            "vehicleData": detailsFromVehiclePage?.vehicleData,
            "existingAreaOfOperation": detailsFromVehiclePage?.existingAreaOfOperation,
            "acceptedTerms": checkTermChecked
        }
        localStorage.setItem('tranporterDetails', JSON.stringify(dataToBePassed));
        navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/vehicleDetails' : "/preregistration/transporter_details/vehicleDetails", { state: { data: dataToBePassed } });

        }
    const getUpdatedAddressData = (data) => {
        setDetails({
            ...details,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,

        })
    }
    const handleChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails({ ...details, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails({ ...details, revenueCircle: e.target.value, });
        }
    }
    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG13</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} navigateTo="/webRegSidebar" />
                    <Typography variant="h5" gutterBottom>
                        {t('preReg.transporter')}{t('preReg.r')} {t('preReg.pre-registration')}
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Typography variant="subtitle2" gutterBottom>
                            {t('preReg.applicantType')}
                        </Typography>
                        <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                            color="primary"
                            value={selectedApplicant}
                            exclusive
                            onChange={(e) => onApplicantClick(e)}
                            aria-label="Platform"
                        >
                            <ToggleButton value="Individual">{t('preReg.individual')}</ToggleButton>
                            <ToggleButton value="Partnership">{t('preReg.partnership')}</ToggleButton>
                            <ToggleButton value="Proprietorship">{t('preReg.proprietorship')}</ToggleButton>
                            <ToggleButton value="Company">{t('preReg.company')}</ToggleButton>
                        </ToggleButtonGroup>
                        <Grid container spacing={2} direction="row" mt={1}>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.fullNameError}
                                            helperText={errorMessage.fullNameError}
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            label={t('preReg.applicantName')}
                                            name="fullName"
                                            value={details.fullName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.fullName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.contactPersonDetails')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.salutation')}</InputLabel>
                                            <Select
                                                label={t('preReg.salutation')}
                                                name='contactPersonSalutation'
                                                value={details.contactPersonSalutation}
                                                onChange={(e) => handleChange(e)}
                                                onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }}>
                                                {SALUTATION.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.contactPersonNameError}
                                            helperText={errorMessage.contactPersonNameError}
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            label={t('preReg.firstname')}
                                            name="contactPersonFirstName"
                                            value={details.contactPersonFirstName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.contactPersonFirstName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            label={t('preReg.middlename')}
                                            name="contactPersonMiddleName"
                                            value={details.contactPersonMiddleName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.contactPersonMiddleName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            maxLength={maxNameLength}
                                            label={t('preReg.lastname')}
                                            name="contactPersonLastName"
                                            value={details.contactPersonLastName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.contactPersonLastName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.gender')}</InputLabel>
                                            <Select
                                                label={t('preReg.gender')}
                                                name='contactPersonGender'
                                                value={details?.contactPersonGender}
                                                onChange={(e) => handleChange(e)}>
                                                {GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.mobileNoError}
                                            helperText={errorMessage.mobileNoError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.mobileNo')}
                                            name="mobileNo"
                                            value={details.mobileNo}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === 'Enter') && evt.preventDefault()}
                                            disabled={mobileOTPValidated} />
                                            <BadgeComponent currentLength={details?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                                        {mobileOTPValidated === true && <div className="commonVerifyText" hidden={!mobileOTPValidated}><a href="#">Verified</a>
                                            <img className="commonOtpImg" src={resolveIcon} alt="" /></div>}
                                    </Grid>
                                    {/*{verifyMobileNo &&*/}
                                    {/*    <Grid item xs={3}>*/}
                                    {/*        <TextField*/}
                                    {/*            type="number"*/}
                                    {/*            onChange={(e) => onOtpChange(e)}*/}
                                    {/*            value={otpValue}*/}
                                    {/*            label={t('preReg.otp')}*/}
                                    {/*            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === 'Enter') && evt.preventDefault()} />*/}
                                    {/*    </Grid>*/}
                                    {/*}*/}
                                </Grid>
                                {/*<Grid item xs={12}>*/}
                                {/*    {verifyMobileNo === true ?*/}
                                {/*        <div>*/}
                                {/*            <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend otp</a></div>*/}
                                {/*        : mobileOTPValidated === true ? <div hidden={!mobileOTPValidated} className="commonVerifyText"><a href="#">Verified</a>*/}
                                {/*            <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :*/}
                                {/*            <button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>*/}
                                {/*    }*/}
                                {/*</Grid>*/}
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            inputProps={{
                                                maxLength: emailUrnPassMaxLength,
                                                style: { textTransform: "none" }
                                            }}
                                            error={errorMessage.emailIdError}
                                            helperText={errorMessage.emailIdError}
                                            type="text"
                                            label={t('main.email')}
                                            name="emailId"
                                            value={details.emailId}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.emailId?.length} maxLength={emailUrnPassMaxLength} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.addressError}
                                            helperText={errorMessage.addressError}
                                            type="text"
                                            label={t('main.officeAddressTitle')}
                                            name="address"
                                            value={details.address}
                                            multiline                                            
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.address?.length} maxLength={addressMaxLength} />
                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                    revenueNotRequired={true}
                                        pincode={details?.pincode}
                                        state={details?.state}
                                        district={details?.district}
                                        revenueCircle={details?.revenueCircle}
                                        blockName={details?.blockName}
                                        onHandleCallback={getUpdatedAddressData}
                                        pincodeError={errorMessage.pincodeError}
                                        searchError={errorMessage.searchError}
                                        handleChangeSelect={handleChangeSelect}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={checkTermChecked} onChange={(e) => handleCheckboxTerms(e)} disabled={checkTermDisable} />} label={<><label for="chkTerms"> I agree to the <a href={LINKS.PRIVACY_POLICY}>Privacy Policy</a> and <a href={LINKS.TERMS_OF_USE}>Terms of Use</a> of ABEPL.</label></>} ></FormControlLabel>
                        </FormGroup>
                        <div style={{ color: "#d32f2f", fontSize: "0.75 rem" }}>{errorMessage.acceptTermError}</div>
                    </Grid>
                    <Grid item xs={3}>
                        {verifyMobileNo &&

                            <TextField fullWidth
                                type="number"
                                onFocus={handleNumberFieldFocus}
                                onKeyDown={(evt) => typeNumberValid(evt)}
                                onChange={(e) => onOtpChange(e)}
                                label={t('preReg.otp')}
                                value={otpValue} />

                        }
                        {verifyMobileNo === true &&
                            <div>
                                <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                        }
                    </Grid>
                </Grid>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100, marginRight: 1 }} variant="outlined" onClick={(e) => clear(e)} startIcon={<CloseIcon />}>{t('preReg.clear')}</Button>
                    <Button disabled={!mobileOTPValidated} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onClickNext(e)} endIcon={<ArrowForwardIosIcon />}>{t('preReg.next')}</Button>
                </Box>
            </Container>
        </>

    );
}

export default TransporterDetails;